import React, { useCallback, useMemo, useState } from 'react';
import { createPortal, flushSync } from 'react-dom';
import { Modal } from 'react-bootstrap';
import SiteMap from './SiteMap';
import SiteMapPrintSheet from './SiteMapPrintSheet';
import {
  PRINT_ROOT_ID,
  getPrintLayout,
  triggerBrowserPrint
} from './siteMapPrintUtils';
import './SiteMapPrint.css';

const SiteMapPopup = ({ site, show, onHide, onSiteUpdate,pickerMode = false,onPickerUnitSelect, excludedUnitIds = []}) => {
  const [printedAt, setPrintedAt] = useState('');

  const occupiedSlot = useMemo(() => {
    return site?.slots?.filter(item => item?.inventory !== null).length;
  }, [site]);

  const printLayout = useMemo(() => getPrintLayout(), []);

  const handlePrint = useCallback(() => {
    flushSync(() => {
      setPrintedAt(new Date().toLocaleString());
    });
    triggerBrowserPrint();
  }, []);

  return (
    <>
      <Modal className="fullscreen-modal" show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header className="p-2" closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex align-items-center justify-content-between w-100 pr-4">
              <h6 className="mb-0">{pickerMode ? 'Select unit from' : 'Site Map'} ({site?.name})</h6>
              <h6 className="mb-0 mid ml-auto">
                <b>{occupiedSlot}</b> of <b>{site?.slots?.length}</b> Slots Occupied
              </h6>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {site && (
            <SiteMap
              site={site}
              onSiteUpdate={onSiteUpdate}
              pickerMode={pickerMode}
              onPickerUnitSelect={onPickerUnitSelect}
              excludedUnitIds={excludedUnitIds}
              onPrint={handlePrint}
            />
          )}
        </Modal.Body>
      </Modal>

      {show &&
        site &&
        createPortal(
          <div id={PRINT_ROOT_ID}>
            <SiteMapPrintSheet
              site={site}
              occupiedCount={occupiedSlot}
              totalSlots={site.slots?.length || 0}
              printedAt={printedAt || new Date().toLocaleString()}
              mapSize={printLayout.mapSize}
            />
          </div>,
          document.body
        )}
    </>
  );
};

export default SiteMapPopup;
